// removed by extract-text-webpack-plugin
module.exports = {"root":"StatusPanel_root_zdx","x":"StatusPanel_x_2sK"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/StatusPanel/StatusPanel.css
 ** module id = 570
 ** module chunks = 0
 **/